export const paths = {
  root: '/',
  about: '/about',
  signIn: '/sign-in',
  forgotPassword: '/forgot-password',
  changePassword: '/change-password',
  unauthorized: '/unauthorized',
  notFound: '/404',
  serverError: '/500',
  auth: {
    createProcurer: '/create/procurer',
    createProcurerSuccess: '/create/procurer/success',
  },
  procurer: {
    contracts: '/procurer/contracts',
    preferences: {
      root: '/procurer/preferences',
      geography: '/procurer/preferences/geography',
      themes: '/procurer/preferences/themes',
      impact: '/procurer/preferences/impact',
      scoring: '/procurer/preferences/scoring',
      qualitative: '/procurer/preferences/qualitative',
      finalizing: '/procurer/preferences/finalizing',
    },
    applications: {
      root: '/procurer/applications',
      singleApplication: '/procurer/applications/:applicationId',
    },
    contract: {
      root: '/procurer/contract/start',
      start: '/procurer/contract/:id/start',
      getContractStartPath: (id: string | number) => `/procurer/contract/${id}/start`,
      details: '/procurer/contract/:id/details',
      getContractDetailsPath: (id: string | number) => `/procurer/contract/${id}/details`,
      geography: '/procurer/contract/:id/geography',
      getGeographyPath: (contractId: string | number) =>
        `/procurer/contract/${contractId}/geography`,
      themes: '/procurer/contract/:id/themes',
      getThemesPath: (contractId: string | number) => `/procurer/contract/${contractId}/themes`,
      impact: '/procurer/contract/:id/impact',
      getImpactPath: (contractId: string | number) => `/procurer/contract/${contractId}/impact`,
      scoring: '/procurer/contract/:id/scoring',
      getScoringPath: (contractId: string | number) => `/procurer/contract/${contractId}/scoring`,
      qualitative: '/procurer/contract/:id/qualitative',
      getQualitativePath: (contractId: string | number) =>
        `/procurer/contract/${contractId}/qualitative`,
      finalizing: '/procurer/contract/:id/finalizing',
      getFinalizingPath: (contractId: string | number) =>
        `/procurer/contract/${contractId}/finalizing`,
      previousDelivery: '/procurer/contract/:id/previous-delivery',
      getPreviousDeliveryPath: (contractId: string | number) =>
        `/procurer/contract/${contractId}/previous-delivery`,
      // #634: keyed by the period's report id, which is what both the context and the submit take.
      // No cut-off in the URL: the period is fixed on the report, so it cannot be steered by a link.
      backfillReport: '/procurer/contract/:contractId/previous-delivery/:reportId/report',
      getBackfillReportPath: (contractId: string | number, reportId: string | number) =>
        `/procurer/contract/${contractId}/previous-delivery/${reportId}/report`,
      success: '/procurer/contract/:contractId/success',
      getCreateContractSuccessPath: (contractId: string | number) =>
        `/procurer/contract/${contractId}/success`,
      reviewReport: '/procurer/contracts/:contractId/review-report/:reportId',
      getReviewReportPath: (contractId: string | number, reportId: string | number) =>
        `/procurer/contracts/${contractId}/review-report/${reportId}`,
    },
  },
  dashboard: {
    contracts: '/dashboard/contracts',
    publicContracts: '/dashboard/public/:procurerId/contracts',
    getPublicContractsPath: (procurerId: string | number) =>
      `/dashboard/public/${procurerId}/contracts`,
    contract: '/dashboard/contracts/:contractId',
    getSingleContractPath: (contractId: string | number) => `/dashboard/contracts/${contractId}`,
    newReport: '/dashboard/contracts/:contractId/reports/new',
    contractsOpenForTender: '/dashboard/contracts/open-for-tender',
    awardContract: (contractId: string | number) =>
      `/dashboard/contracts/${contractId}/award-contract`,
    finalizeContract: (contractId: string | number) =>
      `/dashboard/contracts/${contractId}/finalize-awarded-contract`,
    singleContractOpenForTender: '/dashboard/contracts/open-for-tender/:id',
    getSingleContractOpenForTender: (contractId: string | number) =>
      `/dashboard/contracts/open-for-tender/${contractId}`,
  },
  supplier: {
    signup: '/supplier/signup',
    signupWithInvitation: '/supplier/signup/:inviteToken',
    submitApplication: '/supplier/application/:id',
    privacyPolicy: '/supplier/contracts/:contractId/privacy-policy',
    getPrivacyPolicyPath: (contractId: string | number) =>
      `/supplier/contracts/${contractId}/privacy-policy`,
    editReport: '/supplier/contracts/:contractId/reports/:reportId/edit',
    getEditReportPath: (contractId: string, reportId: string) =>
      `/supplier/contracts/${contractId}/reports/${reportId}/edit`,
    viewReport: '/supplier/contracts/:contractId/reports/:reportId/view',
    getViewReportPath: (contractId: string | number, reportId: string | number) =>
      `/supplier/contracts/${contractId}/reports/${reportId}/view`,
    submitReport: '/dashboard/contracts/:contractId/reports/new',
    getSubmitReportPath: (contractId: string) => `/dashboard/contracts/${contractId}/reports/new`,
    success: '/supplier/application/:id/success',
    getSubmitApplicationPath: (applicationId: string | number) =>
      `/supplier/application/${applicationId}?step=introduction`,
  },
};
